module.exports = __webpack_public_path__ + "static/media/Screenshot 2024-01-02 at 21-30-33 Kobo Kanaeru x Tokopedia.261824e7.png";